export default __webpack_public_path__ + "static/media/4.570a1435.jpg";